import React, { useEffect } from "react";
import { useHistory } from "react-router-dom";
import { useDispatch } from "react-redux";
import { setActivePage } from "../redux/actions/appSettingsActions";
import { fetchAddressResultFromCookie } from "../redux/actions/addressingResultActions";
import { setActiveLanguage } from "../redux/actions/appSettingsActions";
import { useCookies } from "react-cookie";
import axios from "axios";
import { appConifg } from "../config/default";
import { setUserCredentials } from "../redux/actions/appSettingsActions";
import { setAlert } from "../redux/actions/appSettingsActions";
import { useTranslation } from "react-i18next";

const LoginUaePassCallback = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const { t, i18n } = useTranslation("uaePassPage");
  //const [cookies, setCookie] = useCookies(["page"]);
  const [cookiesStore, setCookieStore, removeCookieStore] = useCookies([
    "store",
    "language",
  ]);
  useEffect(() => {
    if (getQueryVariable("state"))
      dispatch(setActivePage(getQueryVariable("state")));
    if (cookiesStore.store) {
      dispatch(fetchAddressResultFromCookie(cookiesStore.store));
      removeCookieStore("store");
    }
    if (cookiesStore.language) {
      dispatch(setActiveLanguage(cookiesStore.language));
      i18n.changeLanguage(cookiesStore.language);
      removeCookieStore("language");
    }
    if (getQueryVariable("state")) {
      if (getQueryVariable("error") || getQueryVariable("error_description")) {
        if (
          getQueryVariable("error") == "access_denied" ||
          getQueryVariable("error_description").includes("Cancelled")
        )
          dispatch(
            setAlert({
              isAlert: true,
              alertMsg: t("WarningMsg1"),
            })
          );
        else
          dispatch(
            setAlert({
              isAlert: true,
              alertMsg: t("WarningMsg2"),
            })
          );
        history.push("/" + getQueryVariable("state"));
        return;
      }
      let data = {
        code: getQueryVariable("code"),
      };

      axios
        .post(appConifg.Address.AddressApiUrl + "/UAEPass/GetUserDetails", data)
        .then((response) => {
          console.log(response);
          if (response.data?.isSucceeded) {
            dispatch(
              setUserCredentials({ data: response.data.data, flag: true })
            );
            if (response.data.data.uaePassUser.userType == "SOP1") {
              dispatch(
                setAlert({
                  isAlert: true,
                  alertMsg: t("WarningMsgSOP1"),
                })
              );
            } else if (response.data.data.uaePassUser.userType == "SOP2") {
              dispatch(
                setAlert({
                  isAlert: true,
                  alertMsg: t("WarningMsgSOP2"),
                })
              );
            }
            history.push("/" + getQueryVariable("state"));
          } else {
            dispatch(
              setAlert({
                isAlert: true,
                alertMsg: t("WarningMsg3"),
              })
            );
            history.push("/Map");
          }
        })
        .catch((ex) => {
          dispatch(
            setAlert({
              isAlert: true,
              alertMsg: t("WarningMsg3"),
            })
          );
          history.push("/Map");
        });
    } else {
      if (cookiesStore.language) {
        dispatch(setActiveLanguage(cookiesStore.language));
        i18n.changeLanguage(cookiesStore.language);
        removeCookieStore("language");
        if (cookiesStore.language == "en") {
          document.body.classList.remove("rtllayout");
          document.body.classList.add("ltrlayout");
        } else {
          document.body.classList.remove("ltrlayout");
          document.body.classList.add("rtllayout");
        }
      }
      history.push("/Map");
    }
  }, []);

  const getQueryVariable = (variable) => {
    var query = window.location.search.substring(1);
    console.log(query); //"app=article&act=news_content&aid=160990"
    var vars = query.split("&");
    console.log(vars); //[ 'app=article', 'act=news_content', 'aid=160990' ]
    for (var i = 0; i < vars.length; i++) {
      var pair = vars[i].split("=");
      console.log(pair); //[ 'app', 'article' ][ 'act', 'news_content' ][ 'aid', '160990' ]
      if (pair[0] == variable) {
        return pair[1];
      }
    }
    return false;
  };

  return <></>;
};

export default LoginUaePassCallback;
